import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ReportSummaryRowItem } from './ReportSummary.types';

interface Props {
  isTotalModeLastItem?: boolean;
  subsidiaryIndex?: number;
  headers: ReportSummaryRowItem[];
  rows: ReportSummaryRowItem[][];
  isPreviewMode?: boolean;
}

const BASE_WIDTH = 125;

const getPreviewWidth = (item: ReportSummaryRowItem) => {
  return `${item.width || BASE_WIDTH * (item.flex || 0) || 250}px`;
};
const ReportSummaryBaseTable: React.FC<Props> = ({
  headers,
  rows,
  isTotalModeLastItem,
  isPreviewMode,
  subsidiaryIndex = 1,
}) => {
  return (
    <Box direction="column">
      {!isTotalModeLastItem && (
        <Box
          data-testid={`report-summary_subsidiary_${subsidiaryIndex}_total_wrapper`}
          direction="row"
          pad={{ vertical: 'spacing8' }}
          border={{ side: 'horizontal', size: 'small', color: 'border1' }}
        >
          {headers?.map((header, indexing) => (
            <Box
              key={indexing}
              pad={{ right: 'spacing24' }}
              style={{
                flex: header.width ? undefined : header.flex || 1,
                minWidth: isPreviewMode ? getPreviewWidth(header) : undefined,
              }}
            >
              <Text
                title={typeof header.value === 'string' ? (header.value as string) : undefined}
                color="textSecondary"
                data-testid={`report-summary_subsidiary_${subsidiaryIndex}_header_${indexing + 1}`}
                size="small"
                weight={500}
                truncate
              >
                {header.value}
              </Text>
            </Box>
          ))}
        </Box>
      )}

      <Box margin={{ top: isTotalModeLastItem ? undefined : 'spacing8' }}>
        {rows?.map((rowItems, rIndex) => (
          <Box
            direction="row"
            background={isTotalModeLastItem ? 'warningBorder' : undefined}
            pad={{ left: isTotalModeLastItem ? 'spacing4' : undefined }}
            round={isTotalModeLastItem ? 'dropdownItemRound' : undefined}
            key={rIndex}
            data-testid={`report-summary_subsidiary_${subsidiaryIndex}_row_${rIndex + 1}`}
            height={{ min: '24px' }}
            align="center"
          >
            {rowItems.map((item, cIndex) => (
              <Box
                style={{
                  flex: item.width ? undefined : item.flex || 1,
                  minWidth: isPreviewMode ? getPreviewWidth(item) : undefined,
                }}
                pad={{ right: 'spacing24' }}
                key={`${rIndex} ${cIndex}`}
              >
                <Text
                  size="small"
                  data-testid={`report-summary_subsidiary_${subsidiaryIndex}_row_${rIndex + 1}_column_${
                    cIndex + 1
                  }`}
                  weight={item.isTotal || isTotalModeLastItem ? 700 : 500}
                  title={item.value as string}
                  truncate
                >
                  {item.value}
                </Text>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
      <Box></Box>
    </Box>
  );
};

export default ReportSummaryBaseTable;
